import React, { useContext, useRef, useEffect } from "react";
import { useClickOutside } from "hooks";

import Stack from "react-bootstrap/Stack";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { MegaNavContainer, NavTitle, NavColumn, NavSide } from "./components";
import { HeaderContext, NavContext } from "contexts";

export default function MegaNav(props) {
	if (!props.data) return <></>;

	const megaNavRef = useRef();
	const { setMegaNavName, megaNavName, scrollHeaderLimit, hasSubNav } = useContext(NavContext);
	const { isMobileNavOpen, width } = useContext(HeaderContext);

	useClickOutside(megaNavRef, isMobileNavOpen, () => setMegaNavName(""));

	let { data, left } = props;
	const hasSide = data.side;
	let hideSide = false;

	if (width < 1100 && megaNavName === "Career") {
		left = "-7em";
		hideSide = true;
	}

	return (
		<div ref={megaNavRef} className={`megaNav expand ${isMobileNavOpen ? "" : "myShow"}`}>
			{/* MegaNav on mobile */}
			<Stack className="d-lg-none">
				<Row className={`ps-3 pe-4 col-12  pt-1 mb-1`}>
					{data.sections.map((section, i) => (
						<Col xs={12} key={i}>
							<NavColumn key={section.title} data={section} />
						</Col>
					))}
				</Row>
			</Stack>

			{/* Mega nave on Desktop */}
			<MegaNavContainer className=" d-none d-lg-block" left={left}>
				{/* <Row className="g-0"> */}
				<Row className="flex-nowrap g-0  ">
					{/* if there is no side element, full 12 col and add padding right */}
					{/* <Col className={`ms3 pe-xl-5  ${hasSide ? "col-xl-9" : ""} pt-4 mb-5`}> */}
					<Col className={`p-4`}>
						{/* Title */}
						<Row className="pb-2">
							<NavTitle title={data.title} />
						</Row>
						{/* Sections */}
						<Row className="flex-nowrap pe-xl-2 g-0">
							{data.sections.map((section, i) => (
								<Col className="navColumn" key={i}>
									<NavColumn key={section.title} data={section} />
								</Col>
							))}
						</Row>
					</Col>
					{/* Side */}
					{hasSide && !hideSide && (
						<div className={`side-col col`}>
							<NavSide data={data.side} />
						</div>
					)}
				</Row>
				{/* </Row> */}
			</MegaNavContainer>

			<style jsx>{`
				.megaNav {
					position: relative;
					z-index: 10000;
				}

				.navColumn {
					min-width: 300px;
				}
			`}</style>
		</div>
	);
}
